import React, {FC, Fragment} from 'react';

import AdRepeated from 'components/Common/AdRepeated';
import useTimelineData from 'hooks/useTimelineData';
import {Sport, TeamInfo, TimelineUpdate, TimelineUpdateType} from '../../../utils/types';

import {
  TimelineUpdateEditor,
  TimelineUpdateGoal,
  TimelineUpdateSimple,
  TimelineUpdateStatus,
} from '../TimelineUpdates';

import './styles.scss';

interface Props {
  updates: TimelineUpdate[];
  sport: Sport;
  teams: {home: TeamInfo; away: TeamInfo};
  commentaryEnabled: boolean;
}

const Timeline: FC<Props> = ({updates, sport, teams, commentaryEnabled}: Props) => {
  return (
    <section className="Timeline">
      <div className="Timeline__updates">
        {updates.map((update, i) => {
          let event;

          switch (update.type) {
            case TimelineUpdateType.OPEN_TEXT:
            case TimelineUpdateType.EDITOR_INFO:
            case TimelineUpdateType.EDITOR_HIGHLIGHT:
            case TimelineUpdateType.EXPERT_COMMENT:
            case TimelineUpdateType.PHOTO_HIGHLIGHT:
            case TimelineUpdateType.VIDEO_HIGHLIGHT:
            case TimelineUpdateType.SOCIAL:
            case TimelineUpdateType.SPONSORED:
            case TimelineUpdateType.OPTA_DATA:
            case TimelineUpdateType.GOOD_OPPORTUNITY:
            case TimelineUpdateType.GOOD_MOMENT:
            case TimelineUpdateType.HISTORIC_FACT:
            case TimelineUpdateType.VIOLENT_INCIDENT:
            case TimelineUpdateType.VAR:
            case TimelineUpdateType.BUZZER_BEATER:
            case TimelineUpdateType.FIVE_OMADIKO_FAUL:
            case TimelineUpdateType.ON_FIRE:
            case TimelineUpdateType.REFEREE:
            case TimelineUpdateType.TECHNICAL_PENALTY:
            case TimelineUpdateType.DISQUALIFICATION:
              event = commentaryEnabled && <TimelineUpdateEditor {...{update}} />;
              break;
            case TimelineUpdateType.SCORE_CHANGE:
            case TimelineUpdateType.AUTOGOAL:
              if (sport === Sport.BASKETBALL) event = <TimelineUpdateSimple update={update} />;
              else event = <TimelineUpdateGoal {...{update}} teams={teams} />;
              break;
            case TimelineUpdateType.MATCH_STARTED:
            case TimelineUpdateType.MATCH_ENDED:
            case TimelineUpdateType.BREAK_START:
            case TimelineUpdateType.PERIOD_START:
            case TimelineUpdateType.PERIOD_SCORE:
            case TimelineUpdateType.PERIOD_ENDED:
            case TimelineUpdateType.PENALTY_SHOOTOUT:
            case TimelineUpdateType.INJURY_TIME_SHOWN:
              event = <TimelineUpdateStatus {...{update}} teams={teams} />;
              break;
            default:
              event = <TimelineUpdateSimple {...{update}} />;
          }

          return (
            <Fragment key={`${update.id}-container`}>
              {event}
              <AdRepeated
                adUnitRoot="sport24.gr/Matchcenter_ros_300x250"
                adUnitLetters={['A', 'B', 'C', 'D']}
                index={i}
                step={15}
                scope="timeline"
                sizes={[
                  [300, 250],
                  [320, 100],
                ]}
                sizeMapping={[
                  {viewport: [1024, 0], sizes: []},
                  {
                    viewport: [0, 0],
                    sizes: [
                      [300, 250],
                      [320, 100],
                    ],
                  },
                ]}
              />
            </Fragment>
          );
        })}
      </div>
    </section>
  );
};

export default Timeline;
